"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Button = _interopRequireDefault(require("../Button"));
// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';

var ThumbnailPreview = function ThumbnailPreview(props) {
  var imageUrl = props.imageUrl,
    className = props.className,
    style = props.style,
    _props$showZoomInIcon = props.showZoomInIcon,
    showZoomInIcon = _props$showZoomInIcon === void 0 ? true : _props$showZoomInIcon,
    _props$showZoomOutIco = props.showZoomOutIcon,
    showZoomOutIcon = _props$showZoomOutIco === void 0 ? true : _props$showZoomOutIco,
    _props$showRotateIcon = props.showRotateIcon,
    showRotateIcon = _props$showRotateIcon === void 0 ? false : _props$showRotateIcon,
    _props$showFullIcon = props.showFullIcon,
    showFullIcon = _props$showFullIcon === void 0 ? false : _props$showFullIcon;

  // 放大按钮
  var zoomInIcon = /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7803495,2.5879595 C14.0781495,4.8857295 14.2959495,8.4758195 12.4338495,11.0186495 L15.3158495,13.9016495 L13.9016495,15.3158495 L11.0186495,12.4338495 C8.4758195,14.2959495 4.8857295,14.0781495 2.5879595,11.7803495 C0.0495475,9.2419395 0.0495475,5.1263595 2.5879595,2.5879595 C5.1263595,0.0495475 9.2419395,0.0495475 11.7803495,2.5879595 Z M4.0021695,4.0021695 C2.2448095,5.7595295 2.2448095,8.6087695 4.0021695,10.3661495 C5.7595295,12.1234495 8.6087695,12.1234495 10.3661495,10.3661495 C12.1234495,8.6087695 12.1234495,5.7595295 10.3661495,4.0021695 C8.6087695,2.2448095 5.7595295,2.2448095 4.0021695,4.0021695 Z M8.1841495,4.6841495 L8.1841495,6.1841495 L9.6841495,6.1841495 L9.6841495,8.1841495 L8.1841495,8.1841495 L8.1841495,9.6841495 L6.1841495,9.6841495 L6.1841495,8.1841495 L4.6841495,8.1841495 L4.6841495,6.1841495 L6.1841495,6.1841495 L6.1841495,4.6841495 L8.1841495,4.6841495 Z"
  }));
  // 缩小按钮
  var zoomOutIcon = /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7803495,2.5879595 C14.0781495,4.8857295 14.2959495,8.4758195 12.4338495,11.0186495 L15.3158495,13.9016495 L13.9016495,15.3158495 L11.0186495,12.4338495 C8.4758195,14.2959495 4.8857295,14.0781495 2.5879595,11.7803495 C0.0495475,9.2419395 0.0495475,5.1263595 2.5879595,2.5879595 C5.1263595,0.0495475 9.2419395,0.0495475 11.7803495,2.5879595 Z M4.0021695,4.0021695 C2.2448095,5.7595295 2.2448095,8.6087695 4.0021695,10.3661495 C5.7595295,12.1234495 8.6087695,12.1234495 10.3661495,10.3661495 C12.1234495,8.6087695 12.1234495,5.7595295 10.3661495,4.0021695 C8.6087695,2.2448095 5.7595295,2.2448095 4.0021695,4.0021695 Z M9.6841495,6.1841495 L9.6841495,8.1841495 L4.6841495,8.1841495 L4.6841495,6.1841495 L9.6841495,6.1841495 Z"
  }));
  // 刷新按钮
  var rotateIcon = /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.99999979,6.04044621 L7.99999979,4.04854342 C5.80293102,4.04854342 4.01619421,5.83528022 4.01619421,8.032349 C4.01664239,8.8449059 4.26699469,9.6376633 4.73327922,10.303158 L3.30906872,11.7273685 C2.50732785,10.7095062 2.02429142,9.42871269 2.02429142,8.032349 C2.02429142,4.7320549 4.6997057,2.05664063 7.99999979,2.05664063 L7.99999979,0 L10.987854,3.02072158 L7.99999979,6.04044621 Z M11.2667204,5.76157982 L12.6909309,4.33736932 C13.5234466,5.38900436 13.9762061,6.69108134 13.9757086,8.032349 C13.9757086,11.332673 11.3002839,14.0080972 7.99999979,14.0080972 L7.99999979,16 L5.01214561,12.9802754 L7.99999979,9.95955479 L7.99999979,12.0161944 C10.1970686,12.0161944 11.9838054,10.2294576 11.9838054,8.032349 C11.9832078,7.21982197 11.7328256,6.42711438 11.2667204,5.76157982 Z"
  }));
  // 全屏按钮
  var fullIcon = /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1,6 L1,1 L6,1 L6,3.001 L3,3.001 L3,6 L1,6 Z M10,3.001 L10,1 L15,1 L15,6 L13,6 L13,3.001 L10,3.001 Z M13,10 L13,13.001 L10,13.001 L10,15 L15,15 L15,10 L13,10 Z M1,15 L1,10 L3,10 L3,13.001 L6,13.001 L6,15 L1,15 Z"
  }));
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('thumbnail-preview');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__player")
  }, !!imageUrl && /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "_image"),
    src: imageUrl
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__toolbar")
  }, showZoomInIcon && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "\u653E\u5927"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link-weak",
    prefixIcon: zoomInIcon
  })), showZoomOutIcon && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "\u7F29\u5C0F"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link-weak",
    prefixIcon: zoomOutIcon
  })), showRotateIcon && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "\u65CB\u8F6C"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link-weak",
    prefixIcon: rotateIcon
  })), showFullIcon && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "\u9002\u5E94\u5C4F\u5E55"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "link-weak",
    prefixIcon: fullIcon
  }))));
};
ThumbnailPreview.defaultProps = {};
var _default = exports.default = ThumbnailPreview;